import { getDetailedSiteAnalytics } from "./asyncThunks";

export const getDetailedSiteAnalyticsBuilder = (builder) => {
  builder.addCase(getDetailedSiteAnalytics.pending, (state) => {
    state.detailedSiteAnalytics.loading = true;
    state.detailedSiteAnalytics.error = null;
  });
  builder.addCase(getDetailedSiteAnalytics.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.detailedSiteAnalytics.data = data;
    state.detailedSiteAnalytics.loading = false;
  });
  builder.addCase(getDetailedSiteAnalytics.rejected, (state, action) => {
    state.detailedSiteAnalytics.loading = false;
    state.detailedSiteAnalytics.error = action.error.message;
  });
};
